import axios from 'axios'

export default async period => {
    try{
        const   path = `/hr_salary_settlement/store_empty_salary_settlement`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route, period)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}
